import { jsxs, jsx } from 'react/jsx-runtime';
import { VisuallyHidden } from '@flex-design-system/fx';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { useState } from 'react';
import { FileUploadDropOverlay } from './components/DropOverlay.mjs';
import { FileUploadDropZone } from './components/DropZone.mjs';
import { FileUploadFileList } from './components/FileList.mjs';
import { FileUploadTrigger } from './components/Trigger.mjs';
import { FileUploadProvider } from './context.mjs';
import { getFilesFromEvent } from './utils/getFilesFromEvent.mjs';

function FileUpload({
  children,
  id,
  name,
  accept,
  files: filesFromProps,
  defaultFiles: defaultFilesFromProps,
  onFilesChange,
  disabled = false,
  multiple = false,
  droppable = true
}) {
  const [files = [], setFiles] = useControllableState({
    prop: filesFromProps,
    defaultProp: defaultFilesFromProps,
    onChange: onFilesChange
  });
  const [dragging, setDragging] = useState(false);
  const [inputElement, setInputElement] = useState(
    null
  );
  const handleChange = (event) => {
    const filesFromEvent = getFilesFromEvent(event);
    setFiles(filesFromEvent);
  };
  return /* @__PURE__ */ jsxs(
    FileUploadProvider,
    {
      files,
      onFilesChange: setFiles,
      disabled,
      multiple,
      droppable,
      dragging,
      onDraggingChange: setDragging,
      inputElement,
      children: [
        children,
        /* @__PURE__ */ jsx(VisuallyHidden, { asChild: true, children: /* @__PURE__ */ jsx(
          "input",
          {
            type: "file",
            tabIndex: -1,
            id,
            name,
            accept,
            multiple,
            onChange: handleChange,
            ref: setInputElement
          }
        ) })
      ]
    }
  );
}
FileUpload.Trigger = FileUploadTrigger;
FileUpload.DropZone = FileUploadDropZone;
FileUpload.DropOverlay = FileUploadDropOverlay;
FileUpload.FileList = FileUploadFileList;

export { FileUpload };
//# sourceMappingURL=FileUpload.mjs.map
